import React, { useState, forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";

const Input = forwardRef(
  (
    {
      Icon,
      label,
      placeholder,
      classes = "",
      isForgotPassword = false,
      labelClasses = "",
      iconClasses = "",
      inputClasses = "",
      type = "text",
      defaultChecked, // Checkbox specific prop
      value, // Checkbox value prop
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

    const togglePasswordVisibility = () => {
      setShowPassword((prevState) => !prevState);
    };

    return (
      <div className={classes}>
        {!isForgotPassword ? (
          <label
            className={`${labelClasses} mb-2 text-[12px] font-medium text-black block`}
          >
            {label}
          </label>
        ) : (
          <div className="flex justify-between items-center">
            <label className="mb-2 text-[12px] font-medium text-black block">
              {label}
            </label>
            <NavLink
              to="/forgot-password"
              className="text-[13px] font-medium text-[#306BFF] cursor-pointer"
            >
              Forgot password?
            </NavLink>
          </div>
        )}

        <div className="relative flex items-center">
          {type === "checkbox" ? (
            <div className="relative h-4 w-4">
              <input
                ref={ref}
                type="checkbox"
                defaultChecked={defaultChecked}
                value={value}
                className="absolute w-full h-full cursor-pointer rounded-md border-blue-color border-[1px] focus:ring-0 appearance-none peer"
                {...props}
              />
            </div>
          ) : (
            <input
              ref={ref}
              type={
                type === "password" && !showPassword
                  ? "password"
                  : type === "number"
                  ? "number"
                  : "text"
              } // Toggle between "password", "number", and "text"
              placeholder={placeholder}
              className={`pr-10 ${
                Icon ? "pl-14" : "pl-5"
              } ${inputClasses} py-3 text-[#06152B] rounded w-full placeholder:text-500-gray text-sm focus:outline-dark-blue`}
              {...props}
            />
          )}

          {Icon &&
            type !== "checkbox" && ( // Only show icon for non-checkbox inputs
              <div className={`left-5 absolute ${iconClasses}`}>
                <Icon className="w-[16px] h-[16px]" />
              </div>
            )}

          {type === "password" && (
            <div
              className="right-4 absolute cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <EyeOffIcon className="w-[16px] h-[16px]" />
              ) : (
                <EyeIcon className="w-[16px] h-[16px]" />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default Input;
